import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const MarketplaceEnhancements = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default MarketplaceEnhancements